export default function RouteError() {
  return (
    <section>
      <h2>Route Error</h2>
      <p>There seems to be an error with the route.</p>
      <p>Leave it with us to resolve ^-^</p>
    </section>
  )
}